import React, { Component } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "./ContactSection5.css";

export default class ContactSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
      sending: false,
    };
  }

  sendEmail = (e) => {
    e.preventDefault();

    if (!this.state.captcha) {
      alert("נא לאשר שאתה לא רובוט 🤖");
      return;
    }

    // התחלת שליחה
    this.setState({
      sending: true,
    });

    emailjs
      .sendForm(
        "service_z61yzfo",
        "template_f41rbnw",
        e.target,
        "iT7YbqtR1ZmPR7EOD"
      )
      .then(
        () => {
          alert("הודעה נשלחה בהצלחה 👍, ניצור קשר בקרוב");

          e.target.reset();

          this.setState({
            captcha: null,
            sending: false,
          });
        },
        (error) => {
          console.log("EmailJS Error:", error);

          alert("ההודעה לא נשלחה. נסו שוב.");

          this.setState({
            sending: false,
          });
        }
      );
  };

  handleCaptchaChange = (value) => {
    this.setState({
      captcha: value,
    });
  };

  render() {
    return (
      <section className="contact-section" dir="rtl">

        <div className="contact-container">

          <div className="contact-heading">

            <span className="contact-badge">
              נצר הובלות ומנופים בע״מ
            </span>

            <h2>
              צריכים הובלה או מנוף?
            </h2>

            <p>
              השאירו לנו את הפרטים ונחזור אליכם עם פתרון
              מקצועי, מהיר ומתאים בדיוק לצורך שלכם.
            </p>

          </div>


          <div className="contact-grid">


            <form
              className="contact-form"
              onSubmit={this.sendEmail}
            >

              <div className="form-header">

                <span>
                  קבלת הצעת מחיר
                </span>

                <h3>
                  השאירו פרטים ונחזור אליכם
                </h3>

              </div>


              <div className="form-group">

                <label htmlFor="name">
                  שם מלא
                </label>

                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="הקלידו שם מלא"
                  required
                />

              </div>


              <div className="form-group">

                <label htmlFor="phone">
                  טלפון
                </label>

                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder="050-0000000"
                  required
                />

              </div>


              <div className="form-group">

                <label htmlFor="message">
                  איך נוכל לעזור?
                </label>

                <textarea
                  id="message"
                  name="message"
                  placeholder="ספרו לנו בקצרה על ההובלה, המנוף או העבודה שאתם צריכים..."
                  rows="5"
                  required
                />

              </div>


              <div className="captcha-wrapper">

                <ReCAPTCHA
                  sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                  onChange={this.handleCaptchaChange}
                />

              </div>


              {/* =================================================
                  SUBMIT BUTTON
              ================================================= */}

              <button
                type="submit"
                className={`submit-btn ${
                  this.state.sending ? "sending" : ""
                }`}
                disabled={this.state.sending}
              >

                {this.state.sending ? (
                  <>
                    <span className="spinner"></span>

                    <span>
                      שולח...
                    </span>
                  </>
                ) : (
                  <>
                    <span>
                      שלחו פרטים
                    </span>

                    <span className="submit-arrow">
                      ←
                    </span>
                  </>
                )}

              </button>

            </form>


            <div className="contact-info">

              <div className="info-top">

                <div className="logo-wrapper">

                  <img
                    src="/logo193.jpeg"
                    alt="נצר הובלות ומנופים"
                    className="logo-top"
                  />

                </div>

                <h3>
                  שירות מקצועי !
                  <br />
                  הובלה בטוחה !
                  <br />
                  פתרון מדויק !
                </h3>

                <p>
                  אנחנו מספקים שירותי הובלה, מנופים,
                  הרמות ושינוע ללקוחות פרטיים ועסקיים.
                </p>

              </div>


              <div className="info-details">

                <a
                  href="https://www.google.com/maps/search/?api=1&query=רחוב+העוגן+9+יבנה"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-item"
                >

                  <div className="info-icon">
                    📍
                  </div>

                  <div>
                    <span>
                      כתובת
                    </span>

                    <strong>
                      רח׳ העוגן 9, יבנה
                    </strong>
                  </div>

                </a>


                <a
                  href="tel:0506615262"
                  className="info-item"
                >

                  <div className="info-icon">
                    ☎
                  </div>

                  <div>
                    <span>
                      טלפון
                    </span>

                    <strong dir="ltr">
                      050-6615262
                    </strong>
                  </div>

                </a>


                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=Netzerhovalot@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-item"
                >

                  <div className="info-icon">
                    ✉
                  </div>

                  <div>
                    <span>
                      אימייל
                    </span>

                    <strong dir="ltr">
                      Netzerhovalot@gmail.com
                    </strong>
                  </div>

                </a>

              </div>


              <div className="info-services">

                <span>
                  השירותים שלנו
                </span>

                <div className="service-tags">

                  <span>
                    הובלות
                  </span>

                  <span>
                    מנופים
                  </span>

                  <span>
                    הרמות
                  </span>

                  <span>
                    שינוע
                  </span>

                  <span>
                    הובלות מיוחדות
                  </span>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>
    );
  }
}
